export default __webpack_public_path__ + "static/media/share-alt.d60b3006.svg";